// extracted by mini-css-extract-plugin
module.exports = {"update":"CoverImage-module__update___3hctz","title":"CoverImage-module__title___2f-zU"};